export default "/images/vendor/flag-icons/flags/1x1/nu.svg?c4afdde3280afe436fc8e050473ca945";